import React, { useEffect, useState } from "react";
import {
  Stack,
  Checkbox,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Button,
  Typography,
  Box,
  Grid,
} from "@mui/material";
import { globalTheme } from "../../styles";

const ReusableForm = ({ formData, handleChange }) => {
  return (
    <Grid container spacing={2}>
      {formData.map((field, index) => {
        if (field.type === "checkbox") {
          return (
            <Grid item xs={12} key={index}>
              <FormControl>
                <Stack direction="row" alignItems="center">
                  <Checkbox checked={field.value} onChange={(e) => handleChange(index, e.target.checked)} />
                  <Typography>{field.label}</Typography>
                </Stack>
              </FormControl>
            </Grid>
          );
        } else if (field.type === "input") {
          return (
            <Grid alignItems="center" item xs={12} sm={6} key={index}>
              <TextField
                label={field.label}
                value={field.value}
                onChange={(e) => handleChange(index, e.target.value)}
                variant="standard"
                fullWidth
              />
            </Grid>
          );
        } else if (field.type === "select") {
          return (
            <Grid item xs={12} sm={6} key={index}>
              <FormControl fullWidth>
                <InputLabel>{field.label}</InputLabel>
                <Select value={field.value} onChange={(e) => handleChange(index, e.target.value)}>
                  {field.options.map((option, optIndex) => (
                    <MenuItem key={optIndex} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          );
        }
        return null;
      })}
    </Grid>
  );
};

export const InternationalConsignmentDetails = ({ handleSubmit, orderId }) => {
  const [consignmentForm, setConsignmentForm] = useState([
    { id: 0, label: "Whether the Item has Commercial Value?", type: "checkbox", value: false },
    { id: 1, label: "Import Reference Number", type: "input", value: orderId },
    { id: 2, label: "Item Description", type: "input", value: "" },
    { id: 3, label: "Export Declaration Number", type: "input", value: "" },
    {
      id: 4,
      label: "Product Classification",
      type: "select",
      value: "",
      options: ["Sale Of Goods", "Gift", "Commercial Sample", "Other", "Returned Goods"],
    },
  ]);

  const [itemsForm, setItemsForm] = useState([
    { id: 0, label: "Country of Origin", type: "input", value: "AU" },
    { id: 1, label: "Tariff Code", type: "input", value: "" },
    { id: 2, label: "Quantity", type: "input", value: parseInt("1") },
    { id: 3, label: "Unit Value (AUD)", type: "input", value: parseFloat("0") },
    { id: 4, label: "Weight(Kg)", type: "input", value: parseFloat("0") },
    { id: 5, label: "Description", type: "input", value: "" },
    { id: 6, label: "Tariff Concession", type: "input", value: "" },
  ]);

  const handleConsignmentChange = (index, value) => {
    const updatedForm = [...consignmentForm];
    updatedForm[index].value = value;
    setConsignmentForm(updatedForm);

    handleSubmit({
      consignmentForm: updatedForm,
      itemsForm,
    });
  };

  const handleItemsChange = (index, value) => {
    const updatedForm = [...itemsForm];
    updatedForm[index].value = value;
    setItemsForm(updatedForm);

    handleSubmit({
      consignmentForm,
      itemsForm: updatedForm,
    });
  };

  return (
    <>
      {/* Form UI remains the same */}
      <Stack mr={4} spacing={2} justifyContent="space-evenly" alignItems="center" mt={2}>
        <Stack spacing={2} width="100%" maxWidth="600px" mt={4}>
          <div>
            <Typography
              variant="subtitle1"
              component="span"
              sx={{
                backgroundColor: globalTheme.background,
                color: globalTheme.primaryColor,
                p: 1,
                borderRadius: 2,
              }}
            >
              Add Consignment:
            </Typography>
          </div>

          <ReusableForm formData={consignmentForm} handleChange={handleConsignmentChange} />
          <div>
            <Typography
              variant="subtitle1"
              component="span"
              sx={{
                backgroundColor: globalTheme.background,
                color: globalTheme.primaryColor,
                p: 1,
                borderRadius: 2,
              }}
            >
              Items:
            </Typography>
          </div>

          <ReusableForm formData={itemsForm} handleChange={handleItemsChange} />
        </Stack>
      </Stack>
    </>
  );
};
